(function (appComponents) {

	appComponents.controllers.errorPage = function (Components) {
		var errorPage = {};

		errorPage.name = "errorPage";


		Components.getControllerPrototype().extend(errorPage);

		// errorPage._cart = errorPage._getService("cartBase");

		errorPage.bindings = function () {

			// $("[pc-container='product--details-datapack']").off().click(function() {
			// 	var type = $(this).attr("pc-value");
			// 	errorPage.handlers.onDataPackItemClick(type);
			// });
		};

		errorPage.populateInitialContext = function () {
			var errorContainer = errorPage._stash.error;

			errorPage.context.errorCode = errorContainer.status;
			errorPage.context.errorMessage = errorContainer.message;

			return $.Deferred().resolve();
		};


		errorPage.handlers = {

			// onDataPackItemClick: function (type) {
			// 	var stockId = errorPage.context.product.stockId;
			// 	errorPage._product.downloadDataPack(stockId, type);
			// },
		};

		errorPage.init = function () {

			errorPage.populateInitialContext().then(function () {

				errorPage._renderPageTemplate();

				errorPage._stash.error = null;

				errorPage._events.dispatchEvent("controllerInitialized");

			});

		};

		return errorPage;
	};

	window.appComponents = appComponents;

})(window.appComponents || {});